module.exports = __webpack_public_path__ + "static/media/deleteCreditCard.952837e7.svg";